/* eslint-disable react/jsx-no-constructed-context-values */

import React, { createContext, useState } from 'react';

export const ChatContext = createContext(
  undefined,
);

export function ChatProvider({
  children, chatId, requestId, clientId,
}) {
  const [chatStatus, setChatStatus] = useState('normal');

  const publish = ({ variant, text }) => {
    if (variant === 'danger') {
      if (chatStatus !== 'done') {
        setChatStatus('error');
      }
      // eslint-disable-next-line no-console
      console.error(text);
      return;
    }
    // eslint-disable-next-line no-console
    console.log(text);
  };

  const [history, setHistory] = useState([]);

  const addToHistory = (message) => {
    if (message.done) {
      setChatStatus('done');
    }
    setHistory((prevHistory) => [...prevHistory, message]);
  };

  const updateStreamingHistory = (streamedChat) => {
    setHistory((prevHistory) => {
      const updatedHistory = prevHistory.find(
        (item) => item.message_id === streamedChat.message_id,
      )
        ? prevHistory.map((item) => (item.message_id === streamedChat.message_id
          ? { ...item, assistant: item.assistant + streamedChat.assistant }
          : item))
        : [...prevHistory, streamedChat];

      return updatedHistory;
    });
  };

  const updateHistory = (chat) => {
    if (chat.done) {
      setChatStatus('done');
    }
    setHistory((prevHistory) => {
      const updatedHistory = prevHistory.find(
        (item) => item.message_id === chat.message_id,
      )
        ? prevHistory.map((item) => (item.message_id === chat.message_id
          ? { ...item, assistant: chat.assistant }
          : item))
        : [...prevHistory, chat];

      return updatedHistory;
    });
  };

  return (
    <ChatContext.Provider
      value={{
        history,
        setHistory,
        addToHistory,
        updateHistory,
        updateStreamingHistory,
        chatId,
        requestId,
        clientId,
        chatStatus,
        setChatStatus,
        publish,
      }}
    >
      {children}
    </ChatContext.Provider>
  );
}
